const formatNumber = (value) => {
  if (value >= 1000 && value < 1000000) {
    return (value / 1000).toFixed(3).replace(".", ",");
  } else {
    return value.toString();
  }
};

export default formatNumber;
